import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { THEME_CONSTANTS } from '../../../utils/constants';
import RadioGroup from '../radio';
import CustomThemeSection from '../customtheme';
import MerchantLogoSection from '../merchantLogoSection';
import api from '../../../common/api';
import { onChange } from '../../../controller/theme_checkout';
import NotificationSuccess from '../async/notificationsuccess';
import Notification from '../async/notification';
import { locale } from '../../../utils/i18n';
import Toggle from '../toggle';
import DragAndDrop from '../draganddrop';
import common from '../../../common/common';
import style from './style.css';
// import CodeIntegration from '../async/codeintegration';
import Button from '../button';
import { get } from '../../../common/utility';

class ThemeSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resultMsg: '',
      isAppDataUpdated: false,
      isButtonDisabled: false,
      showSuccessMsg: false,
      saveErrorMsg: ''
    };
    this.onSaveClick = this.onSaveClick.bind(this);
    this.closeSuccessMsg = this.closeSuccessMsg.bind(this);
    this.isValidCustomTheme = this.isValidCustomTheme.bind(this);
    this.isThemeSelected = this.isThemeSelected.bind(this);

    this.securePaytmInfo = {
      label: locale('theme.display.secure.label'),
      desc: locale('theme.display.secure.desc')
    };
    this.autoLoginInfo = {
      label: locale('theme.autologin.label'),
      desc: locale('theme.autologin.desc')
    };
    this.gradientInfo = {
      label: locale('theme.gradient.label'),
      desc: locale('theme.gradient.desc')
    };
    this.invertLogoImg = {
      label: locale('theme.invert.logo.label'),
      desc: locale('theme.invert.logo.desc')
    };
  }

  componentDidMount() {
    common.log('onLoad', 'Theme Page');
  }

  isValidCustomTheme = selectedColor => {
    let isValid = true;

    if (selectedColor && selectedColor.mobile) {
      for (let key in selectedColor.mobile) {
        if (
          typeof selectedColor.mobile[key] === 'string' &&
          selectedColor.mobile[key].indexOf('#') === 0 &&
          selectedColor.mobile[key].length <= 3
        ) {
          isValid = false;
        }
      }
    } else {
      isValid = false;
    }
    return isValid;
  };

  onSaveClick = (isGenerateCodeClick = false, event) => {
    event.preventDefault();
    if (this.state.isButtonDisabled) {
      return;
    }
    const {
      selected,
      CHECKOUT_THEME,
      onSaveCustomTheme,
      isPaytmBrandingDisplay,
      isAutoLoginSupported,
      merchantPayModes,
      onKeyValueChange,
      isCustomPaymodeSelected,
      isGradientEffectEnable,
      onInvertImgLogo,
      isParentThemeOverwriteEnabled
    } = this.props;
    const isValidTheme = this.isValidCustomTheme(selected);
    common.log('onSaveClick', get(selected, 'web.NAME', ''), {
      isAutoLoginSupported,
      isPaytmBrandingDisplay,
      isValidTheme,
      selected
    });

    if (isValidTheme) {
      this.setState({ isButtonDisabled: true });
      if (CHECKOUT_THEME) {
        this.setState({ saveErrorMsg: '' });

        const selectedMerchant = { ...selected.merchant };

        Promise.all([
          api.onSaveSetting(
            selected,
            CHECKOUT_THEME,
            isPaytmBrandingDisplay,
            isAutoLoginSupported,
            isCustomPaymodeSelected,
            merchantPayModes,
            isGradientEffectEnable,
            isParentThemeOverwriteEnabled,
            onInvertImgLogo
          ),
          api.onSaveMerchantLogo(
            selectedMerchant && selectedMerchant.merchantLogoFile ? selectedMerchant.merchantLogoFile : null
          )
        ])
          .then(() => {
            this.setState({
              resultMsg: locale('theme.save.success'),
              showSuccessMsg: true,
              isButtonDisabled: false
            });
            if (isGenerateCodeClick && onKeyValueChange) {
              onKeyValueChange('isGenerateCodeStepEnabled', true);
            }
            if (selected.mobile.NAME == THEME_CONSTANTS.CUSTOM && onSaveCustomTheme) {
              onSaveCustomTheme(selected);
            }
            setTimeout(() => {
              this.closeSuccessMsg();
            }, 3000);
          })
          .catch(error => {
            if (error && error.resultInfo) {
              this.setState({
                saveErrorMsg: error.resultInfo.resultMsg,
                isButtonDisabled: false,
                showSuccessMsg: false
              });
            } else {
              this.setState({
                saveErrorMsg: locale('default.error'),
                isButtonDisabled: false,
                showSuccessMsg: false
              });
            }
            setTimeout(() => {
              this.closeSuccessMsg();
            }, 3000);
          });
      } else {
        this.setState({ saveErrorMsg: locale('default.error') });
        setTimeout(() => {
          this.closeSuccessMsg();
        }, 3000);
      }
    } else {
      this.setState({ saveErrorMsg: locale('theme.save.error') });
      setTimeout(() => {
        this.closeSuccessMsg();
      }, 3000);
    }
  };

  closeSuccessMsg() {
    this.setState({
      showSuccessMsg: false,
      isButtonDisabled: false,
      resultMsg: '',
      saveErrorMsg: ''
    });
  }

  onToggleChange = (logType, key, event) => {
    common.log(logType, event.target.checked);
    if (this.props && this.props.onToggleChange) {
      this.props.onToggleChange(key, event.target.checked);
    }
    event.preventDefault();
  };

  // onGenerateCodeClick = key => {
  //   if (this.props && this.props.onKeyValueChange) {
  //     this.onSaveClick();
  //     this.props.onKeyValueChange(key, true);
  //   }
  //   event.preventDefault();
  // };

  isThemeSelected(infoObj, selectedObj) {
    return infoObj && selectedObj && selectedObj.isSelected && infoObj.NAME === selectedObj.NAME;
  }

  onCustomPaymodeChange = (label, key, value, event) => {
    if (this.props && this.props.onKeyValueChange) {
      this.props.onKeyValueChange(key, value);
    }
    common.log('onSortPaymodeChange', label);
    event.preventDefault();
  };

  onThemeChange = (label, WebTheme, MobileTheme, event) => {
    const { onThemeChange } = this.props;
    common.log('onThemeChange', label);
    onThemeChange && onThemeChange(WebTheme, MobileTheme);
    event.preventDefault();
  };

  render(
    {
      selected,
      MobileTheme,
      WebTheme,
      merchantPayModes,
      isAutoLoginSupported,
      isJSCheckoutIntegrated,
      isRedirectionTabSelected,
      isThematicFeatureUsed,
      isCustomPaymodeSelected,
      isGradientEffectEnable,
      onInvertImgLogo
    },
    { resultMsg, showSuccessMsg, saveErrorMsg, isButtonDisabled }
  ) {
    return (
      <div class="left-content left">
        <h5 class="theme-heading">{locale('theme.select.theme')}</h5>
        <div class="theme-wrap">
          <RadioGroup
            label={`${MobileTheme.LIGHTTHEME.LABEL}`}
            inputName={`theme`}
            isChecked={this.isThemeSelected(MobileTheme.LIGHTTHEME, selected.mobile)}
            onChange={this.onThemeChange.bind(
              this,
              MobileTheme.LIGHTTHEME.LABEL,
              WebTheme.LIGHTTHEME,
              MobileTheme.LIGHTTHEME
            )}
          />
          <RadioGroup
            label={`${MobileTheme.DARKTHEME.LABEL}`}
            inputName={`theme`}
            isChecked={this.isThemeSelected(MobileTheme.DARKTHEME, selected.mobile)}
            onChange={this.onThemeChange.bind(
              this,
              MobileTheme.DARKTHEME.LABEL,
              WebTheme.DARKTHEME,
              MobileTheme.DARKTHEME
            )}
          />
          <RadioGroup
            label={`${MobileTheme.CUSTOMTHEME.LABEL}`}
            inputName={`theme`}
            isChecked={this.isThemeSelected(MobileTheme.CUSTOMTHEME, selected.mobile)}
            onChange={this.onThemeChange.bind(
              this,
              MobileTheme.CUSTOMTHEME.LABEL,
              WebTheme.CUSTOMTHEME,
              MobileTheme.CUSTOMTHEME
            )}
          />
          {selected && selected.mobile && selected.mobile.NAME == THEME_CONSTANTS.CUSTOM && <CustomThemeSection />}
          <MerchantLogoSection />
          {selected && selected.mobile && selected.mobile.NAME == THEME_CONSTANTS.CUSTOM && (
            <Toggle
              isChecked={onInvertImgLogo}
              default-checked={true}
              info={this.invertLogoImg}
              onToggleChange={this.onToggleChange.bind(this, 'onInvertImgChange', 'onInvertImgLogo')}
            />
          )}
          {selected &&
            selected.mobile &&
            selected.mobile.NAME == THEME_CONSTANTS.CUSTOM &&
            !isRedirectionTabSelected && (
              <Toggle
                isChecked={isGradientEffectEnable}
                info={this.gradientInfo}
                onToggleChange={this.onToggleChange.bind(this, 'onGradientEffectChange', 'isGradientEffectEnable')}
              />
            )}
        </div>

        {merchantPayModes && merchantPayModes.length > 0 && (
          <div>
            {!isRedirectionTabSelected && (
              <div>
                <h5 class="theme-heading mt-30">{locale('theme.sort.paymodes')}</h5>
                <div class="theme-wrap">
                  <RadioGroup
                    label={locale('theme.default.order')}
                    inputName={`paymode`}
                    isChecked={!isCustomPaymodeSelected}
                    onChange={this.onCustomPaymodeChange.bind(
                      this,
                      locale('theme.default.order'),
                      `isCustomPaymodeSelected`,
                      false
                    )}
                  />
                  <RadioGroup
                    label={locale('theme.customize.order')}
                    inputName={`paymode`}
                    isChecked={isCustomPaymodeSelected}
                    onChange={this.onCustomPaymodeChange.bind(
                      this,
                      locale('theme.customize.order'),
                      `isCustomPaymodeSelected`,
                      true
                    )}
                  />
                  {isCustomPaymodeSelected && <DragAndDrop />}
                </div>
              </div>
            )}
            {/* <Toggle
              isChecked={isPaytmBrandingDisplay}
              info={this.securePaytmInfo}
              onToggleChange={this.onToggleChange.bind(
                this,
                'onSecuredPaytmChange',
                'isPaytmBrandingDisplay'
              )}
            /> */}
            <Toggle
              isChecked={isAutoLoginSupported}
              info={this.autoLoginInfo}
              onToggleChange={this.onToggleChange.bind(this, 'onAutoLoginChange', 'isAutoLoginSupported')}
            />
          </div>
        )}
        {!isJSCheckoutIntegrated && showSuccessMsg && (
          <NotificationSuccess closeSuccessMsg={this.closeSuccessMsg} msg={resultMsg} />
        )}
        {saveErrorMsg && <Notification closeWarningMsg={this.closeSuccessMsg} msg={saveErrorMsg} />}
        {isThematicFeatureUsed && (
          <div className={`${style.notification}`}>
            <span className={`${style['note-txt']}`}>{locale('theme.note')}:</span>
            <span>{locale('theme.note.desc')}</span>
          </div>
        )}
        {!isJSCheckoutIntegrated && (
          <Button
            onButtonClick={this.onSaveClick.bind(this, false)}
            isDisabled={isButtonDisabled}
            name={locale('theme.save.setting')}
          />
        )}
        {isJSCheckoutIntegrated && (
          <Button
            onButtonClick={this.onSaveClick.bind(this, true)}
            name={locale('checkout.generate.code')}
            isDisabled={isButtonDisabled}
          />
        )}
      </div>
    );
  }
}

export default connect(
  'selected, MobileTheme, WebTheme, CHECKOUT_THEME, merchantPayModes, isPaytmBrandingDisplay, isAutoLoginSupported, isThematicFeatureUsed, isJSCheckoutIntegrated, isRedirectionTabSelected, isCustomPaymodeSelected, isGradientEffectEnable, isParentThemeOverwriteEnabled,onInvertImgLogo',
  onChange
)(ThemeSection);



// WEBPACK FOOTER //
// ./checkout/components/themesection/index.js